<template>
  <div class="contact-page" :style="headerOffsetStyle">
    <!-- Header导航栏（复用首页样式） -->
    <header class="website-header" :class="{ 'scrolled': isScrolled, 'mobile-nav-open': mobileNavOpen }">
      <div class="header-container">
        <div class="logo-section" @click="goToHomepage" style="cursor: pointer;">
          <img src="@/assets/logo/logo.png" alt="小虫单" class="logo-img" />
          <span class="logo-text">小虫单</span>
        </div>
        
        <nav class="nav-menu nav-menu--desktop" aria-label="主导航">
          <a href="#home" class="nav-link" @click.prevent="goToHomepage">首页</a>
          <a href="#product-functions" class="nav-link" @click.prevent="goToHomepage">产品功能</a>
          <a href="#pricing" class="nav-link" @click.prevent="goToHomepage">版本价格</a>
          <a href="#about" class="nav-link" @click.prevent="goToHomepage">关于我们</a>
        </nav>
        
        <div class="header-actions header-actions--desktop">
          <el-button type="text" class="action-btn" @click="handleLogin">登录/注册</el-button>
          <el-button type="text" class="download-header-btn" @click="handleDownload">下载小虫单</el-button>
          <el-button type="warning" class="contact-header-btn" @click="handleContact">联系销售</el-button>
        </div>

        <button
          type="button"
          class="mobile-menu-toggle"
          :aria-expanded="mobileNavOpen ? 'true' : 'false'"
          aria-controls="mobile-nav-panel"
          aria-label="更多菜单"
          @click="toggleMobileNav"
        >
          <span class="mobile-menu-bars" aria-hidden="true">
            <span class="mobile-menu-bar"></span>
            <span class="mobile-menu-bar"></span>
            <span class="mobile-menu-bar"></span>
          </span>
        </button>
      </div>

      <Teleport to="body">
        <div
          id="mobile-nav-panel"
          class="mobile-nav-root"
          :class="{ 'is-open': mobileNavOpen }"
          :aria-hidden="mobileNavOpen ? 'false' : 'true'"
        >
          <div class="mobile-nav-backdrop" @click="closeMobileNav"></div>
          <aside class="mobile-nav-panel" role="dialog" aria-modal="true" aria-label="站点菜单" @click.stop>
            <div class="mobile-nav-panel-header">
              <div class="mobile-nav-brand-row">
                <img src="@/assets/logo/logo.png" alt="" class="mobile-nav-brand-logo" width="36" height="36" />
                <span class="mobile-nav-brand">小虫单</span>
              </div>
              <button type="button" class="mobile-nav-close" aria-label="关闭菜单" @click="closeMobileNav">
                <span class="mobile-nav-close-line" aria-hidden="true"></span>
                <span class="mobile-nav-close-line" aria-hidden="true"></span>
              </button>
            </div>
            <nav class="mobile-nav-menu" aria-label="移动端导航">
              <a href="#home" class="mobile-nav-link" :style="{ animationDelay: '0.05s' }" @click.prevent="goToHomepageAndCloseNav">首页</a>
              <a href="#product-functions" class="mobile-nav-link" :style="{ animationDelay: '0.1s' }" @click.prevent="goToHomepageAndCloseNav">产品功能</a>
              <a href="#pricing" class="mobile-nav-link" :style="{ animationDelay: '0.15s' }" @click.prevent="goToHomepageAndCloseNav">版本价格</a>
              <a href="#about" class="mobile-nav-link" :style="{ animationDelay: '0.2s' }" @click.prevent="goToHomepageAndCloseNav">关于我们</a>
            </nav>
            <div class="mobile-nav-cta">
              <el-button type="default" class="mobile-nav-cta-btn mobile-nav-cta-btn--outline" @click="handleDownloadAndCloseNav">下载小虫单</el-button>
              <el-button type="warning" class="mobile-nav-cta-btn mobile-nav-cta-btn--primary" @click="handleContactAndCloseNav">联系销售</el-button>
            </div>
          </aside>
        </div>
      </Teleport>
      
      <!-- Header横幅 -->
      <div class="header-banner">
        <div class="banner-content">
          <div class="banner-text-wrapper">
            <span class="banner-text banner-text-white">小虫单，真简单</span>
            <span class="banner-divider">|</span>
            <span class="banner-text banner-text-yellow">为中小型消杀企业量身打造的移动工单！</span>
            <el-button type="warning" class="banner-trial-btn" @click="handleTrial">免费试用 ></el-button>
          </div>
        </div>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <div class="contact-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">联系我们</h1>
        <p class="page-subtitle">欢迎联系我们,小虫单顾问将为您提供全力支持</p>
      </div>

      <div class="contact-wrapper">
        <!-- 左侧品牌区域 -->
        <div class="brand-panel">
          <div class="brand-logo">
              <img 
                :src="logoImage" 
                alt="小虫单" 
                class="brand-logo-img"
                @error="handleImageError"
              />
          </div>
          <div class="brand-name">小虫单</div>
          <div class="brand-slogan">小虫单,真简单</div>
        </div>

        <!-- 右侧表单区域 -->
        <div class="form-panel">
          <el-form 
            :model="formData" 
            ref="elForm" 
            :rules="rules" 
            @submit.prevent="submitForm"
            class="contact-form"
            label-width="100px"
          >
            <el-form-item prop="name" label="姓名">
              <el-input
                v-model="formData.name"
                placeholder="请输入您的姓名"
                class="form-input"
              />
            </el-form-item>

            <el-form-item prop="phone" label="电话">
              <el-input
                v-model="formData.phone"
                placeholder="请输入您的电话号码"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="职位">
              <el-input
                v-model="formData.position"
                placeholder="请输入您的职位名称"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="企业名称">
              <el-input
                v-model="formData.enterpriseName"
                placeholder="请输入您的企业名称"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="企业规模">
              <el-select
                v-model="formData.scale"
                placeholder="请选择您的企业规模"
                class="form-select"
                style="width: 100%;"
              >
                <el-option label="1-10人" value="1" />
                <el-option label="11-50人" value="2" />
                <el-option label="51-200人" value="3" />
                <el-option label="201人以上" value="4" />
              </el-select>
            </el-form-item>

            <el-form-item label="留言">
              <el-input
                v-model="formData.message"
                type="textarea"
                :rows="4"
                placeholder="请输入您的留言"
                class="form-textarea"
              />
            </el-form-item>

            <el-form-item>
              <el-button
                type="warning"
                class="submit-button"
                :disabled="isSubmitting"
                @click="submitForm"
                :loading="isSubmitting"
              >
                {{ isSubmitting ? `请等待 ${countdown} 秒` : '提交' }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 下载二维码弹窗 -->
    <el-dialog
      :model-value="downloadDialogVisible"
      @update:model-value="handleDialogClose"
      title=""
      :width="downloadDialogWidth"
      :top="downloadDialogTop"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :class="['download-dialog', { 'download-dialog--mobile': isMobileDownload }]"
      center
    >
      <div class="download-content">
        <h2 class="download-title">
          <span class="title-text-black">下载</span>
          <span class="title-text-blue">小虫单APP</span>
        </h2>
        <p class="download-desc">让智能管理赋能虫害防制,让企业更高效、更具竞争力!</p>
        <div class="qr-codes-row">
          <div 
            class="qr-card qr-card-android" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'android' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  src="@/assets/app.png" 
                  alt="安卓下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'android'">
                <img src="@/assets/Android.png" alt="安卓" class="qr-mask-icon" />
                <span class="qr-mask-label">Android 客户端</span>
                <span class="qr-mask-tip">悬停或点击显示二维码</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码下载安卓版</p>
          </div>
          <div 
            class="qr-card qr-card-ios" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'ios' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  :src="iosQrSrc" 
                  alt="iOS下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'ios'">
                <img src="@/assets/Apple.png" alt="苹果" class="qr-mask-icon" />
                <span class="qr-mask-label">iOS & iPadOS 客户端</span>
                <span class="qr-mask-tip">悬停或点击显示二维码</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码跳转 App Store</p>
          </div>
        </div>
        <p v-if="!isMobileDownload" class="download-hint">悬停或点击卡片显示二维码；使用手机浏览器扫一扫下载 APP</p>
        <p v-else class="download-hint download-hint--mobile">已显示二维码，请使用另一台手机扫码下载 APP</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUserRecord } from '@/api/contact'

export default {
  name: 'ContactPage',
  data() {
    return {
      isScrolled: false,
      headerOffsetPx: 114,
      mobileNavOpen: false,
      logoImage: require('@/assets/logo/logo.png'),
      downloadDialogVisible: false,
      /** 用于下载弹窗响应式宽度与文案 */
      windowInnerWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
      qrRevealedPlatform: null,
      formData: {
        name: '',
        phone: '',
        position: '',
        enterpriseName: '',
        scale: '',
        message: '',
        reception: '官网联系',
        channel: '1'
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      },
      isSubmitting: false,
      countdown: 5,
      countdownInterval: null
    }
  },
  computed: {
    qrCodeUrl() {
      const downloadLink = 'https://your-download-link.com'
      const encodedText = encodeURIComponent(downloadLink)
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodedText}`
    },
    iosQrSrc() {
      return require('@/assets/IOS App.png')
    },
    headerOffsetStyle() {
      return {
        '--header-offset': `${this.headerOffsetPx}px`
      }
    },
    isMobileDownload() {
      return this.windowInnerWidth <= 768
    },
    downloadDialogWidth() {
      return this.isMobileDownload ? '92%' : '720px'
    },
    downloadDialogTop() {
      return this.isMobileDownload ? '6vh' : undefined
    }
  },
  watch: {
    mobileNavOpen(val) {
      if (typeof document === 'undefined') return
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.syncHeaderOffset, { passive: true })
    window.addEventListener('resize', this.onResizeCloseMobileNav, { passive: true })
    window.addEventListener('resize', this.updateWindowInnerWidth, { passive: true })
    window.addEventListener('keydown', this.onGlobalKeydown)
    this.updateWindowInnerWidth()
    this.syncHeaderOffset()
    this.$nextTick(() => this.syncHeaderOffset())
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.syncHeaderOffset)
    window.removeEventListener('resize', this.onResizeCloseMobileNav)
    window.removeEventListener('resize', this.updateWindowInnerWidth)
    window.removeEventListener('keydown', this.onGlobalKeydown)
    document.body.style.overflow = ''
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    syncHeaderOffset() {
      this.$nextTick(() => {
        const el = document.querySelector('.website-header')
        if (el) {
          const h = el.offsetHeight
          if (h > 0) this.headerOffsetPx = h
        }
      })
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen
    },
    closeMobileNav() {
      this.mobileNavOpen = false
    },
    onResizeCloseMobileNav() {
      if (typeof window === 'undefined') return
      if (window.innerWidth > 768 && this.mobileNavOpen) {
        this.mobileNavOpen = false
      }
    },
    updateWindowInnerWidth() {
      if (typeof window === 'undefined') return
      this.windowInnerWidth = window.innerWidth
    },
    onGlobalKeydown(e) {
      if (e.key === 'Escape' && this.mobileNavOpen) {
        this.closeMobileNav()
      }
    },
    goToHomepage() {
      this.$router.push('/homepage')
    },
    goToHomepageAndCloseNav() {
      this.closeMobileNav()
      this.goToHomepage()
    },
    handleLogin() {
      window.open('https://platform.xcdan.com/register', '_blank')
    },
    handleDownload() {
      this.qrRevealedPlatform = null
      this.downloadDialogVisible = true
    },
    handleDownloadAndCloseNav() {
      this.closeMobileNav()
      this.handleDownload()
    },
    handleDialogClose(value) {
      this.downloadDialogVisible = value
      if (!value) this.qrRevealedPlatform = null
    },
    handleQrCodeError(event) {
      // 二维码加载失败时的处理
      console.warn('二维码加载失败:', event.target.src)
      // 可以设置一个默认的二维码图片或重新生成
    },
    handleContact() {
      // 已经在联系页面，可以滚动到顶部或不做处理
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleContactAndCloseNav() {
      this.closeMobileNav()
      this.handleContact()
    },
    handleTrial() {
      this.$message.info('免费试用功能开发中...')
    },
    handleImageError(event) {
      // 图片加载失败时的处理
      console.warn('图片加载失败:', event.target.src)
      // 尝试使用备用图片路径
      try {
        this.logoImage = require('@/assets/logo/pure-logo.png')
      } catch (e) {
        console.error('备用图片也加载失败:', e)
      }
    },
    async submitForm() {
      if (this.isSubmitting) return

      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          this.isSubmitting = true
          this.startCountdown()

          try {
            const res = await addUserRecord(this.formData)
            // axios返回的响应结构: res.status是HTTP状态码, res.data是响应数据
            if (res.status === 200 || res.data?.code === 200) {
              this.$message.success('提交成功！我们会在24小时内派专人联系您')
              // 重置表单
              this.formData = {
                name: '',
                phone: '',
                position: '',
                enterpriseName: '',
                scale: '',
                message: '',
                reception: '官网联系',
                channel: '1'
              }
              this.$refs.elForm.resetFields()
            } else {
              this.$message.error(res.data?.msg || '提交失败，请稍后再试！')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('提交失败，请稍后再试！')
          } finally {
            // 确保倒计时结束后重置状态
            setTimeout(() => {
              if (this.countdown <= 0) {
                this.isSubmitting = false
              }
            }, this.countdown * 1000)
          }
        }
      })
    },
    startCountdown() {
      this.countdown = 5
      this.countdownInterval = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval)
          this.isSubmitting = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  --header-offset: 114px;
  min-height: 100vh;
  background: #f5f7fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  scroll-padding-top: var(--header-offset, 120px);
}

// Header样式（完全复用首页样式）
.website-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &.scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-banner {
    background: #1B5898;
    color: #fff;
    padding: 12px 0;

    .banner-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .banner-text-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        flex-wrap: wrap;
        gap: 8px;
        min-width: 0;
      }

      .banner-text {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 0;

        &.banner-text-white {
          color: #ffffff;
          font-size: 20px;
        }

        &.banner-text-yellow {
          color: #FFC133;
        }
      }

      .banner-divider {
        color: #ffffff;
        font-size: 18px;
        margin: 0 20px;
        font-weight: 500;
      }

      .banner-trial-btn {
        background: #FFC133;
        border-color: #FFC133;
        color: #000;
        font-weight: 500;
        padding: 6px 16px;
        border-radius: 12px;
        transition: all 0.3s ease;
        flex-shrink: 0;

        &:hover {
          background: #ffb300;
          border-color: #ffb300;
        }
      }
    }
  }

  .logo-section {
    display: flex;
    align-items: center;
    gap: 12px;
    animation: fadeInLeft 0.6s ease;

    .logo-img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }

    .logo-text {
      font-size: 20px;
      font-weight: 600;
      color: #1B5898;
    }
  }

  .nav-menu {
    display: flex;
    gap: 40px;
    flex: 1;
    justify-content: center;

    .nav-link {
      color: #333;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      transition: color 0.3s ease;
      position: relative;

      &:hover {
        color: #1B5898;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 2px;
        background: #1B5898;
        transition: width 0.3s ease;
      }

      &:hover::after {
        width: 100%;
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 20px;

    .contact-info {
      color: #666;
      font-size: 14px;
    }

    .action-btn {
      color: #333;
      font-size: 14px;
      padding: 0;
      transition: color 0.3s ease;

      &:hover {
        color: #1B5898;
      }
    }

    .download-header-btn {

      border-color: #1B5898;
      color:#1B5898;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #0A3563;
        border-color: #0A3563;
      }
    }

    .contact-header-btn {
      background: #FFC133;
      border-color: #FFC133;
      color: #000;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #ffb300;
        border-color: #ffb300;
      }
    }
  }

  .mobile-menu-toggle {
    display: none;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 44px;
    min-height: 44px;
    margin-left: auto;
    padding: 0 4px 0 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 10px;
    flex-shrink: 0;
    transition: background 0.25s ease, transform 0.25s ease;

    &:hover {
      background: rgba(27, 88, 152, 0.08);
    }

    .mobile-menu-bars {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;
    }

    .mobile-menu-bar {
      display: block;
      width: 22px;
      height: 2px;
      background: #1b5898;
      border-radius: 1px;
      transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.25s ease;
    }
  }

  &.mobile-nav-open .mobile-menu-toggle {
    .mobile-menu-bar:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }

    .mobile-menu-bar:nth-child(2) {
      opacity: 0;
      transform: scaleX(0);
    }

    .mobile-menu-bar:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

.mobile-nav-root {
  display: none;
}

.contact-container {
  min-height: calc(100vh - var(--header-offset, 114px));
  padding: calc(var(--header-offset, 114px) + 32px) 40px 60px;
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

// 页面标题区域
.page-header {
  text-align: center;
  margin-bottom: 50px;
  animation: fadeInUp 0.8s ease;

  .page-title {
    font-size: 48px;
    font-weight: 700;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .page-subtitle {
    font-size: 18px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }
}

.contact-wrapper {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: center;
}

// 左侧品牌面板
.brand-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  animation: fadeInLeft 0.8s ease;
}

.brand-logo {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeInUp 0.8s ease 0.2s both;

  .brand-logo-square {
    width: 120px;
    height: 120px;
    background: #1B5898;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(27, 88, 152, 0.2);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .brand-logo-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    display: block;
    // 如果logo是白色或黑色，需要转换为金色，取消下面的注释
    // 如果logo本身已经是金色，保持注释状态
    // filter: brightness(0) saturate(100%) invert(77%) sepia(95%) saturate(1352%) hue-rotate(1deg) brightness(105%) contrast(105%);
  }
}

.brand-name {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  animation: fadeInUp 0.8s ease 0.4s both;
}

.brand-slogan {
  font-size: 18px;
  color: #666;
  animation: fadeInUp 0.8s ease 0.6s both;
}

// 右侧表单面板（去掉卡片样式）
.form-panel {
  padding: 0;
  animation: fadeInRight 0.8s ease;
}

.contact-form {
  :deep(.el-form-item__content) {
    display: block;
  }

  // 确保 Element Plus 表单正常布局
  :deep(.el-form-item) {
    margin-bottom: 24px;
  }

  :deep(.el-form-item__label) {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  :deep(.el-input__wrapper),
  :deep(.el-select__wrapper) {
    min-height: 46px;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    transition: box-shadow 0.25s ease, transform 0.25s ease;
  }

  :deep(.el-input__wrapper.is-focus),
  :deep(.el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 2px rgba(27, 88, 152, 0.14), 0 0 0 1px #1b5898 inset;
  }

  :deep(.el-input__inner),
  :deep(.el-select__placeholder),
  :deep(.el-select__selected-item) {
    font-size: 15px;
  }

  .form-textarea {
    width: 100%;

    :deep(.el-textarea__inner) {
      border-radius: 8px;
      border: 1px solid #dcdfe6;
      padding: 12px 15px;
      font-size: 14px;
      transition: all 0.3s ease;
      resize: vertical;
      min-height: 100px;

      &:focus {
        border-color: #1B5898;
        box-shadow: 0 0 0 2px rgba(27, 88, 152, 0.1);
      }
    }
  }

  .submit-button {
    width: 50%;
    padding: 26px 14px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 24px;
    background: #FFC133;
    border-color: #FFC133;
    color: #000;
    transition: all 0.3s ease;
    animation: fadeInUp 0.6s ease 0.4s both;
    margin-left: auto;
    margin-right: auto;
    display: block;
    position: relative;

    :deep(span) {
      position: relative;
      top: -5px;
      display: inline-block;
    }

    &:hover:not(:disabled) {
      background: #ffb300;
      border-color: #ffb300;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 193, 51, 0.3);
    }

    &:disabled {
      background: #ccc;
      border-color: #ccc;
      cursor: not-allowed;
      transform: none;
    }
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式设计
@media (max-width: 968px) {
  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .brand-panel {
    order: 2;
  }

  .form-panel {
    order: 1;
  }

}

@media (max-width: 1023px) {
  .website-header {
    .header-container {
      padding: 0 20px;
      min-height: 64px;
      height: 64px;
      gap: 12px;
    }

    .logo-section {
      gap: 10px;

      .logo-img {
        width: 34px;
        height: 34px;
      }

      .logo-text {
        font-size: 17px;
      }
    }

    .nav-menu--desktop,
    .header-actions--desktop {
      display: none !important;
    }

    .mobile-menu-toggle {
      display: flex;
    }

    .header-banner {
      .banner-content {
        padding: 0 20px;
        flex-direction: column;
        gap: 12px;
        text-align: center;

        .banner-text-wrapper {
          width: 100%;
        }

        .banner-text {
          font-size: 14px;

          &.banner-text-white {
            font-size: 16px;
          }
        }

        .banner-divider {
          margin: 0 12px;
          font-size: 14px;
        }

        .banner-trial-btn {
          display: none !important;
        }
      }
    }
  }

  .mobile-nav-root {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 5000;
    pointer-events: none;
    visibility: hidden;
    transition: visibility 0.4s ease;

    &.is-open {
      pointer-events: auto;
      visibility: visible;

      .mobile-nav-backdrop {
        opacity: 1;
      }

      .mobile-nav-panel {
        transform: translateX(0);
      }
    }
  }

  .mobile-nav-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.48);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    opacity: 0;
    transition: opacity 0.38s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .mobile-nav-panel {
    position: absolute;
    top: 0;
    right: 0;
    width: min(88vw, 360px);
    height: 100%;
    max-height: 100dvh;
    background: linear-gradient(165deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: -12px 0 40px rgba(15, 23, 42, 0.14);
    transform: translateX(104%);
    transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1);
    display: flex;
    flex-direction: column;
    padding: calc(12px + env(safe-area-inset-top, 0px)) 0 calc(24px + env(safe-area-inset-bottom, 0px));
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    overflow: hidden auto;
  }

  .mobile-nav-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 20px 20px;
    border-bottom: 1px solid rgba(27, 88, 152, 0.1);
    gap: 12px;
  }

  .mobile-nav-brand-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .mobile-nav-brand-logo {
    width: 36px;
    height: 36px;
    object-fit: contain;
  }

  .mobile-nav-brand {
    font-size: 18px;
    font-weight: 700;
    color: #1b5898;
  }

  .mobile-nav-close {
    position: relative;
    width: 44px;
    height: 44px;
    border: none;
    background: rgba(27, 88, 152, 0.08);
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-nav-close-line {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 18px;
    height: 2px;
    margin-left: -9px;
    margin-top: -1px;
    background: #1b5898;
    border-radius: 1px;

    &:first-child { transform: rotate(45deg); }
    &:last-child { transform: rotate(-45deg); }
  }

  .mobile-nav-menu {
    display: flex;
    flex-direction: column;
    padding: 16px 12px 8px;
    gap: 4px;
    flex: 1;
  }

  .mobile-nav-link {
    display: block;
    padding: 16px 20px;
    font-size: 17px;
    font-weight: 600;
    color: #0f172a;
    text-decoration: none;
    border-radius: 12px;
    opacity: 0;
    transform: translateX(20px);
    transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;
  }

  .mobile-nav-root.is-open .mobile-nav-link {
    opacity: 1;
    transform: translateX(0);
  }

  .mobile-nav-cta {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 20px 8px;
    border-top: 1px solid rgba(148, 163, 184, 0.25);
    margin-top: auto;
  }

  .mobile-nav-cta-btn {
    width: 100%;
    height: 48px !important;
    border-radius: 12px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    margin: 0 !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease !important;

    &:active {
      transform: scale(0.98);
    }
  }

  .mobile-nav-cta-btn.mobile-nav-cta-btn--outline {
    border: 1.5px solid #1b5898 !important;
    color: #1b5898 !important;
    background: #fff !important;
  }

  .mobile-nav-cta-btn.mobile-nav-cta-btn--primary {
    background: #ffc133 !important;
    border-color: #ffc133 !important;
    color: #000 !important;
  }
}

@media (max-width: 768px) {
  .contact-container {
    padding: calc(var(--header-offset, 114px) + 20px) 20px 40px;
  }

  .page-header {
    margin-bottom: 30px;

    .page-title {
      font-size: 32px;
    }

    .page-subtitle {
      font-size: 16px;
    }
  }

  .form-panel {
    padding: 16px 14px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  }

  .contact-form {
    :deep(.el-form-item) {
      flex-direction: column;
      margin-bottom: 18px;

      :deep(.el-form-item__label) {
        width: 100% !important;
        line-height: 1.5;
        margin-bottom: 6px;
        padding-right: 0;
        font-size: 13px;
        color: #475569;
      }

      :deep(.el-form-item__content) {
        width: 100%;
      }
    }

    :deep(.el-input__wrapper),
    :deep(.el-select__wrapper) {
      min-height: 44px;
      border-radius: 10px;
    }

    .form-textarea :deep(.el-textarea__inner) {
      min-height: 110px;
      font-size: 14px;
      border-radius: 10px;
      padding: 10px 12px;
    }

    .submit-button {
      width: 100%;
      min-height: 46px;
      padding: 12px 14px;
      border-radius: 14px;
      margin-top: 6px;

      :deep(span) {
        top: 0;
      }
    }
  }

  .brand-panel {
    .brand-logo .brand-logo-square {
      width: 100px;
      height: 100px;
    }

    .brand-logo .brand-logo-img {
      width: 70px;
      height: 70px;
    }

    .brand-name {
      font-size: 28px;
    }

    .brand-slogan {
      font-size: 16px;
    }
  }

}

@media (max-width: 380px) {
  .contact-container {
    padding: calc(var(--header-offset, 114px) + 16px) 14px 28px;
  }

  .page-header {
    margin-bottom: 22px;

    .page-title {
      font-size: 28px;
    }
  }
}

// 下载二维码弹窗样式
:deep(.download-dialog) {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    max-height: min(92vh, 900px);
    display: flex;
    flex-direction: column;
  }

  .el-dialog__header {
    padding: 0;
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .el-dialog__close {
    color: #333;
    font-size: 24px;
    z-index: 10;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      color: #1B5898;
      transform: rotate(90deg);
    }
  }

  &.download-dialog--mobile {
    .el-dialog {
      max-height: min(88dvh, 900px);
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .el-dialog__close {
      right: max(10px, env(safe-area-inset-right, 10px));
      top: max(10px, env(safe-area-inset-top, 10px));
    }
  }
}

.download-content {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  padding: 60px 40px;
  text-align: center;
  animation: fadeInUp 0.6s ease;

  .download-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;

    .title-text-black {
      color: #000000;
    }

    .title-text-blue {
      color: #1B5898;
    }
  }

  .download-desc {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 40px;
    padding: 0 20px;
  }

  .qr-codes-row {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 32px;
    margin-bottom: 28px;
    flex-wrap: wrap;
  }

  .qr-card {
    flex: 0 0 auto;
    width: 272px;
    background: #ffffff;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 4px 24px rgba(27, 88, 152, 0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    animation: fadeInUp 0.5s ease both;
    border: 1px solid rgba(27, 88, 152, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &.qr-card-android {
      animation-delay: 0.15s;

      &::before {
        background: linear-gradient(90deg, #3ddc84 0%, #2e7d32 100%);
      }
    }

    &.qr-card-ios {
      animation-delay: 0.25s;

      &::before {
        background: linear-gradient(90deg, #555 0%, #1d1d1f 100%);
      }
    }

    &:hover,
    &.is-revealed-tap {
      .qr-mask-layer {
        opacity: 0;
        pointer-events: none;
      }

      .qr-code-layer {
        opacity: 1;
      }
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 16px 36px rgba(27, 88, 152, 0.12);
        border-color: rgba(27, 88, 152, 0.14);

        &::before {
          opacity: 1;
        }
      }
    }

    .qr-card-reveal {
      position: relative;
      width: 200px;
      height: 240px;
      border-radius: 14px;
      overflow: hidden;
      background: #f8fafc;
    }

    .qr-code-layer {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      opacity: 0;
      transition: opacity 0.35s ease;

      .qr-code-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .qr-mask-layer {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 14px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
      opacity: 1;
      transition: opacity 0.35s ease;
      cursor: pointer;
    }

    .qr-mask-icon {
      width: 56px;
      height: 56px;
      object-fit: contain;
      margin-bottom: 14px;
      flex-shrink: 0;
    }

    .qr-mask-label {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      text-align: center;
      line-height: 1.4;
      padding: 0 8px;
    }

    .qr-mask-tip {
      font-size: 12px;
      color: #94a3b8;
      margin-top: 12px;
    }

    .qr-card-hint {
      font-size: 13px;
      color: #64748b;
      margin-top: 16px;
      margin-bottom: 0;
    }
  }

  .download-hint {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
    margin: 0;
    animation: fadeInUp 0.6s ease 0.35s both;

    &--mobile {
      padding: 0 4px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  :deep(.download-dialog) {
    .el-dialog {
      width: 92% !important;
      max-width: calc(100vw - 24px);
      margin: 5vh auto !important;
    }
  }

  .download-content {
    padding: 48px 16px 28px;
    padding-bottom: max(28px, env(safe-area-inset-bottom, 28px));

    .download-title {
      font-size: 22px;
      line-height: 1.35;
      margin-bottom: 12px;
    }

    .download-desc {
      font-size: 14px;
      margin-bottom: 24px;
      padding: 0 4px;
    }

    .qr-codes-row {
      flex-direction: row;
      justify-content: center;
      gap: 10px;
      align-items: stretch;
      margin-bottom: 20px;
    }

    .qr-card {
      flex: 1 1 0;
      width: calc(50% - 6px);
      min-width: 0;
      max-width: 160px;
      margin: 0;
      padding: 14px 10px;

      .qr-card-reveal {
        width: min(120px, 32vw);
        height: auto;
        aspect-ratio: 5 / 6;
        max-height: 150px;
      }

      // 移动端直接展示二维码，无需再点一次遮罩
      .qr-mask-layer {
        opacity: 0;
        pointer-events: none;
      }

      .qr-code-layer {
        opacity: 1;
      }
    }

    .download-hint {
      font-size: 13px;
      padding: 0 8px;
    }
  }
}

@media (max-width: 380px) {
  .download-content {
    padding: 44px 12px 24px;

    .download-title {
      font-size: 20px;
    }

    .qr-codes-row {
      gap: 8px;
    }

    .qr-card {
      max-width: 148px;
      padding: 12px 8px;
    }

    .qr-card .qr-card-reveal {
      width: min(108px, 34vw);
    }
  }
}
</style>

